import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = ["onSubmit"]
const _hoisted_3 = { class: "form-field" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", null, "Fee", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select a fee", -1)
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "form-field" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", null, "Product", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select a fee", -1)
const _hoisted_10 = ["value"]
const _hoisted_11 = { key: 2 }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Total")
], -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_15 = {
  key: 3,
  class: "btn",
  type: "submit"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("button", { class: "btn" }, "Cancel", -1)

import { useRouter } from "vue-router";
import FeeModal from "@/components/FeeModal.vue";
import ProductModal from "@/components/ProductModal.vue";
import { ref } from "vue";
import api from "@virgodev/bazaar/functions/api";
import { FeesProductInterface } from "@/types/customers";

export default /*#__PURE__*/_defineComponent({
  props: {
  customerId: {
    type: String,
    required: false,
    default: null,
  },
  customerName: {
    type: String,
    required: false,
    default: null,
  },
  facilityId: {
    type: String,
    default: null,
  },
},
  emits: ["feesAndProducts"],
  setup(__props, { emit }) {

const props = __props

const formErrors = ref<Record<string, string[]>>({});
const formSubmitting = ref(false);

const router = useRouter();
const fees = ref();
const newFee = ref<FeesProductInterface | null>();
const products = ref();
const feesAndProducts = ref(Array<FeesProductInterface>());
const total = ref(0);
const newProduct = ref<FeesProductInterface | null>();
const errors = ref("");



async function addCost(e: FeesProductInterface) {
  e.description = e.action_name + " due on " + e.due_on.toString();
  feesAndProducts.value.push(e);
  total.value += e.item_subtotal;
  emit("feesAndProducts", e);
}
function removeFee(obj: FeesProductInterface) {
  feesAndProducts.value.splice(
    feesAndProducts.value.indexOf(
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      feesAndProducts.value.find((item: FeesProductInterface) => item == obj)
    ),
    1
  );
  total.value -= obj.item_subtotal;
  emit("feesAndProducts", feesAndProducts.value);
}
async function submitForm() {
  for (let line of feesAndProducts.value) {
    const json = JSON.parse(JSON.stringify(line));
    delete json.item_subtotal;
    formSubmitting.value = true;
    let url = `line_items/?facilityId=${props.facilityId}`;

    const responseData = await api({
      url,
      method: "POST",
      json,
    });
    if ([200, 201].includes(responseData.status)) {
      console.log("UPDATED");
    } else if (responseData.status === 400) {
      formErrors.value = responseData.body;
    } else {
      formErrors.value = {
        non_field_errors: [
          "Unable to communicate with the server. Please check your " +
            "connection and try again.",
        ],
      };
    }
  }
  router.push({
    name: "customer_detail_ess",
    params: {
      id: props.customerId,
      facilityId: props.facilityId,
    },
  });
}
async function modalClosed() {
  newFee.value = null;
  newProduct.value = null;
}

async function getFees() {
  errors.value = "";
  const response = await api({
    url: `fees/?kind=manual&facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    fees.value = response.body;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
async function getProducts() {
  errors.value = "";
  const response = await api({
    url: `products/?facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    products.value = response.body;
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
getFees();
getProducts();

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.customerName)
      ? (_openBlock(), _createBlock(_component_RouterLink, {
          key: 0,
          to: {
      name: 'customer_detail_ess',
      params: { id: __props.customerId, facilityId: __props.facilityId },
    }
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Customer: " + _toDisplayString(__props.customerName), 1)
          ]),
          _: 1
        }, 8, ["to"]))
      : _createCommentVNode("", true),
    (__props.customerName)
      ? (_openBlock(), _createElementBlock("h1", _hoisted_1, "Fees/Product"))
      : _createCommentVNode("", true),
    _createElementVNode("form", {
      style: {"margin-inline":"10px !important"},
      onSubmit: _withModifiers(submitForm, ["prevent"])
    }, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newFee).value = $event)),
          class: "form-select"
        }, [
          _hoisted_5,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fees.value, (fee) => {
            return (_openBlock(), _createElementBlock("option", {
              key: fee.id + 'fee',
              value: fee
            }, _toDisplayString(fee.name), 9, _hoisted_6))
          }), 128))
        ], 512), [
          [_vModelSelect, newFee.value]
        ])
      ]),
      (newFee.value)
        ? (_openBlock(), _createBlock(FeeModal, {
            key: 0,
            name: newFee.value.name,
            "customer-id": Number(__props.customerId),
            "fee-id": Number(newFee.value.id),
            "facility-id": __props.facilityId,
            onModalClosed: modalClosed,
            onFee: addCost
          }, null, 8, ["name", "customer-id", "fee-id", "facility-id"]))
        : _createCommentVNode("", true),
      (newProduct.value)
        ? (_openBlock(), _createBlock(ProductModal, {
            key: 1,
            name: newProduct.value.name,
            "customer-id": Number(__props.customerId),
            "product-id": Number(newProduct.value.id),
            "product-inventory": newProduct.value.inventory,
            "facility-id": __props.facilityId,
            onModalClosed: modalClosed,
            onProduct: addCost
          }, null, 8, ["name", "customer-id", "product-id", "product-inventory", "facility-id"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newProduct).value = $event)),
          class: "form-select"
        }, [
          _hoisted_9,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(products.value, (product) => {
            return (_openBlock(), _createElementBlock("option", {
              key: product.id + 'product',
              value: product
            }, _toDisplayString(product.name), 9, _hoisted_10))
          }), 128))
        ], 512), [
          [_vModelSelect, newProduct.value]
        ])
      ]),
      (feesAndProducts.value.length && __props.customerName)
        ? (_openBlock(), _createElementBlock("table", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(feesAndProducts.value, (item) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: item.id + 'fees'
              }, [
                _createElementVNode("td", null, _toDisplayString(item.action_name) + " due on " + _toDisplayString(item.due_on), 1),
                _createElementVNode("td", null, "$" + _toDisplayString(item.item_subtotal.toFixed(2)), 1),
                _createElementVNode("td", null, [
                  _createElementVNode("a", {
                    onClick: ($event: any) => (removeFee(item))
                  }, "remove", 8, _hoisted_12)
                ])
              ]))
            }), 128)),
            _createElementVNode("tr", null, [
              _hoisted_13,
              _createElementVNode("td", null, "$" + _toDisplayString(total.value.toFixed(2)), 1),
              _hoisted_14
            ])
          ]))
        : _createCommentVNode("", true),
      (__props.customerName)
        ? (_openBlock(), _createElementBlock("button", _hoisted_15, "Save"))
        : _createCommentVNode("", true),
      (__props.customerName)
        ? (_openBlock(), _createBlock(_component_RouterLink, {
            key: 4,
            to: {
        name: 'customer_detail_ess',
        params: { id: __props.customerId, facilityId: __props.facilityId },
      }
          }, {
            default: _withCtx(() => [
              _hoisted_16
            ]),
            _: 1
          }, 8, ["to"]))
        : _createCommentVNode("", true)
    ], 40, _hoisted_2)
  ], 64))
}
}

})